import { render, staticRenderFns } from "./EditEmergencyContactView.vue?vue&type=template&id=591ac118"
import script from "./EditEmergencyContactView.vue?vue&type=script&lang=ts"
export * from "./EditEmergencyContactView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports